<div *ngIf="isPageReady" class="flex flex-col gap-3 p-1">

  <div *ngIf="!rrd" class="text-red-600">RRD #{{ params.rrdId }} not found.</div>

  <div *ngIf="rrd">
    <div class="qb-detail-card qb-primary-tint p-3 mb-3">
      <table class="qb-info-table">
        <tr><td class="label">RRD</td>            <td class="value">#{{ rrd.id }}</td></tr>
        <tr><td class="label">Job Order</td>      <td class="value">{{ rrd.returnRequest?.joHeader?.id }}</td></tr>
        <tr><td class="label">Account</td>        <td class="value">{{ rrd.returnRequest?.joHeader?.account?.accountName }}</td></tr>
        <tr><td class="label">Product</td>        <td class="value">{{ rrd.joDetail?.productTypeConfigName }}</td></tr>
        <tr><td class="label">Declared Qty</td>   <td class="value">{{ rrd.qty }}</td></tr>
        <tr><td class="label">Received Qty</td>   <td class="value">{{ rrd.receivedQty }}</td></tr>
        <tr><td class="label">Reason</td>         <td class="value">{{ rrd.returnReasonType?.name }}</td></tr>
        <tr><td class="label">Customer Notes</td> <td class="value">{{ rrd.returnExplanation }}</td></tr>
      </table>
    </div>

    <div class="text-sm text-muted mb-2">
      Inspect the received items and choose how to dispose of them.
    </div>

    <div class="flex flex-col gap-2 mb-3">
      <div *ngFor="let d of availableDecisions"
           class="qb-detail-card p-3 cursor-pointer"
           [class.qb-primary-tint]="selectedDecision === d.value"
           (click)="selectDecision(d.value)">
        <div class="flex items-start gap-3">
          <p-radioButton
            name="decision"
            [value]="d.value"
            [(ngModel)]="selectedDecision"
            inputId="decision-{{ d.value }}">
          </p-radioButton>
          <div class="flex-1">
            <label for="decision-{{ d.value }}" class="font-semibold cursor-pointer">{{ d.label }}</label>
            <div class="text-sm text-muted">{{ d.description }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="qb-detail-card p-3 mb-3 text-sm">
      <div class="font-semibold mb-2">How these options were chosen</div>
      <ul class="list-none pl-0 space-y-1 mb-2">
        <li *ngFor="let fact of matrixFacts" class="flex items-start gap-2">
          <i class="pi" [ngClass]="fact.ok ? 'pi-check-circle text-green-700' : 'pi-times-circle text-red-600'"></i>
          <div class="flex-1">
            <div>{{ fact.label }}</div>
            <div class="text-xs text-muted">{{ fact.detail }}</div>
          </div>
        </li>
      </ul>
      <div class="text-xs text-muted italic">{{ matrixOutcome }}</div>
    </div>

    <div class="mb-3">
      <label class="block font-semibold mb-1">Notes (optional)</label>
      <textarea #notesInput
                pTextarea
                rows="3"
                class="w-full"
                title="Decision notes"
                [(ngModel)]="decisionNotes"
                [disabled]="submitting"
                placeholder="e.g. Unworn, original tags attached. Repackable."></textarea>
    </div>

    <div *ngIf="errorMessage" class="text-red-600 mb-2">{{ errorMessage }}</div>
  </div>

  <div class="flex justify-end gap-2 pt-3 border-t">
    <button pButton type="button"
            class="p-button-text"
            [disabled]="submitting"
            (click)="cancel()">
      <span>Cancel</span>
    </button>
    <button pButton type="button"
            class="p-button-raised"
            icon="pi pi-check"
            [disabled]="!canSubmit"
            (click)="confirm()">
      <span>Record Inspection</span>
    </button>
  </div>
</div>
